import { render, staticRenderFns } from "./PopularStreams.vue?vue&type=template&id=8c2dd89a&"
import script from "./popularStreams.js?vue&type=script&lang=js&"
export * from "./popularStreams.js?vue&type=script&lang=js&"
import style0 from "./PopularStreams.vue?vue&type=style&index=0&id=8c2dd89a&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports